"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const useIntroEDS = () => {
    const [postCreateCreditApp] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsCreateMutation)();
    const { data: dataFeatureFlags } = (0, consumer_applications_v2_api_1.useGetConsumerApplicationsV2FeatureFlagsGlobalQuery)({});
    return {
        postCreateCreditApp,
        dataFeatureFlags,
    };
};
exports.default = useIntroEDS;
